import { createContext, useContext, useState } from 'react';

interface SampleContextType {
    recordedBlob: Blob | null;
    setRecordedBlob: (blob: Blob | null) => void;
    uploadedFiles: File[] | null;
    setUploadedFiles: (files: File[] | null) => void;
    sampleDuration: number;
    setSampleDuration: (duration: number) => void;
    capturedImage: Blob | null;
    setCapturedImage: (blob: Blob | null) => void;
}

const SampleContext = createContext<SampleContextType | undefined>(undefined);

export const useSample = () => {
    const context = useContext(SampleContext);
    if (!context) {
        throw new Error('useSample must be used within an AudioProvider');
    }
    return context;
};

export const SampleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
    const [uploadedFiles, setUploadedFiles] = useState<File[] | null>(null);
    const [sampleDuration, setSampleDuration] = useState<number>(0);
    const [capturedImage, setCapturedImage] = useState<Blob | null>(null);

    return (
        <SampleContext.Provider
            value={{
                recordedBlob,
                setRecordedBlob,
                uploadedFiles,
                setUploadedFiles,
                sampleDuration,
                setSampleDuration,
                capturedImage,
                setCapturedImage,
            }}
        >
            {children}
        </SampleContext.Provider>
    );
};